import { Link } from 'react-router-dom';
import { BADGE_RED } from '../shell/GlanceCard';

/**
 * SF-122: shared notification-bell button for the app-shell identity header (mobile + desktop).
 * Reuses the existing `useUnreadCount`/`getUnreadCount` notifications API (SF-72) — a real
 * `<button>`-shaped link (not a styled `<span>`), min 44×44px hit target, visible unread-count
 * badge, matching `Sidebar.tsx`'s existing badge convention.
 */
interface NotificationBellLinkProps {
  unreadCount: number;
}

export function NotificationBellLink({ unreadCount }: NotificationBellLinkProps) {
  return (
    <Link
      to="/recent-news"
      aria-label={unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications'}
      className="relative flex items-center justify-center flex-shrink-0 rounded-md hover:text-white"
      style={{ width: 44, height: 44, color: '#7b83a5' }}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        />
      </svg>
      {unreadCount > 0 && (
        <span
          style={{
            position: 'absolute',
            top: 2,
            right: 2,
            fontSize: 10,
            fontWeight: 700,
            backgroundColor: BADGE_RED,
            color: '#fff',
            borderRadius: 8,
            padding: '1px 5px',
            minWidth: 16,
            textAlign: 'center',
          }}
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </Link>
  );
}
